/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".kt-header__topbar-wrapper[_ngcontent-%COMP%]{position:relative}.notification-number[_ngcontent-%COMP%]{position:absolute;top:12px;right:0;padding-left:12px;padding-right:12px}"];
export { styles as styles };
